import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CriarPerfilLayer from "../components/CriarPerfilLayer";
import { useTranslation } from "../i18n/I18nContext";

const CriarPerfilPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("perfis.breadcrumb.create")} />
      <CriarPerfilLayer />
    </MasterLayout>
  );
};

export default CriarPerfilPage;
